import { useMemo, useState } from 'react';
import { useMutation, useQuery } from 'urql';
import { CREATE_RETORNABLE_TIPO, RETORNABLES_TIPOS_QUERY, UPDATE_RETORNABLE_TIPO } from '@/graphql/retornables.gql.js';

const emptyForm = { codigo: '', nombre: '', capacidadUnidades: '', descripcion: '', activo: true };

export default function RetornablesTipos() {
  const [search, setSearch] = useState('');
  const [activo, setActivo] = useState('todos');
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);

  const [result, refetch] = useQuery({
    query: RETORNABLES_TIPOS_QUERY,
    variables: { search: search || undefined, activo: activo === 'todos' ? undefined : activo === 'activos' },
  });
  const [, createTipo] = useMutation(CREATE_RETORNABLE_TIPO);
  const [, updateTipo] = useMutation(UPDATE_RETORNABLE_TIPO);

  const tipos = useMemo(() => result.data?.retornablesTipos || [], [result.data]);

  const onSubmit = async e => {
    e.preventDefault();
    const payload = { ...form, capacidadUnidades: form.capacidadUnidades ? Number(form.capacidadUnidades) : null };
    if (editingId) await updateTipo({ id: editingId, input: payload });
    else await createTipo({ input: payload });
    setForm(emptyForm);
    setEditingId(null);
    refetch({ requestPolicy: 'network-only' });
  };

  return (
    <div className="mx-auto w-full max-w-[1400px] space-y-4 px-4 py-4">
      <h1 className="text-2xl font-semibold">Descripción de Envases</h1>
      <div className="grid grid-cols-12 gap-4">
        <section className="col-span-12 rounded-2xl border border-[rgba(var(--border),0.45)] bg-[rgb(var(--panel))] p-4">
          <div className="mb-3 flex flex-wrap gap-2">
            <input aria-label="Buscar tipo" className="rounded-xl border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2" value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar por código o nombre" />
            <select aria-label="Filtro activo" className="rounded-xl border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2" value={activo} onChange={e => setActivo(e.target.value)}>
              <option value="todos">Todos</option>
              <option value="activos">Activos</option>
              <option value="inactivos">Inactivos</option>
            </select>
          </div>

          {!result.fetching && tipos.length === 0 ? <div className="rounded-xl border border-dashed border-[rgba(var(--border),0.7)] p-6 text-sm">No hay tipos cargados. Creá el primer tipo.</div> : null}
          <table className="w-full text-sm">
            <thead><tr><th className="text-left">Código</th><th className="text-left">Nombre</th><th>Capacidad</th><th>Estado</th><th /></tr></thead>
            <tbody>
              {tipos.map(item => (
                <tr key={item.id} className="border-t border-[rgba(var(--border),0.4)]">
                  <td>{item.codigo}</td><td>{item.nombre}</td><td className="text-center">{item.capacidadUnidades || '-'}</td>
                  <td className="text-center"><span className="rounded-full border border-[rgba(var(--border),0.6)] px-2 py-1">{item.activo ? 'Activo' : 'Inactivo'}</span></td>
                  <td className="text-right"><button className="rounded-lg border border-[rgba(var(--border),0.6)] px-2 py-1" onClick={() => { setEditingId(item.id); setForm(item); }}>Editar</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <form className="col-span-12 rounded-2xl border border-[rgba(var(--border),0.45)] bg-[rgb(var(--panel))] p-4" onSubmit={onSubmit}>
          <div className="grid grid-cols-12 gap-3">
            <input required className="col-span-12 md:col-span-3 rounded-xl border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2" placeholder="Código" value={form.codigo} onChange={e => setForm(v => ({ ...v, codigo: e.target.value }))} />
            <input required className="col-span-12 md:col-span-4 rounded-xl border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2" placeholder="Nombre" value={form.nombre} onChange={e => setForm(v => ({ ...v, nombre: e.target.value }))} />
            <input className="col-span-12 md:col-span-2 rounded-xl border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2" placeholder="Capacidad" value={form.capacidadUnidades} onChange={e => setForm(v => ({ ...v, capacidadUnidades: e.target.value }))} />
            <label className="col-span-12 md:col-span-3 flex items-center gap-2"><input type="checkbox" checked={form.activo} onChange={e => setForm(v => ({ ...v, activo: e.target.checked }))} />Activo</label>
            <textarea className="col-span-12 rounded-xl border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2" placeholder="Descripción" value={form.descripcion || ''} onChange={e => setForm(v => ({ ...v, descripcion: e.target.value }))} />
          </div>
          <div className="sticky bottom-0 mt-4 flex justify-end gap-2 border-t border-[rgba(var(--border),0.5)] bg-[rgb(var(--panel))] py-3">
            <button type="button" className="rounded-xl border border-[rgba(var(--border),0.6)] px-4 py-2" onClick={() => { setForm(emptyForm); setEditingId(null); }}>Limpiar</button>
            <button type="submit" className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-[rgb(var(--bg))]">{editingId ? 'Actualizar' : 'Crear tipo'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
